import UtilService from "../../service/UtilService";

const AuditlogExpandedRow = ({ auditlog }) => {
  return (
    <div style={{ padding: "1em" }}>
      <h4>Audit Log Details</h4>

      {/* Basic info table - compact */}
      <table className="config-table" style={{ marginBottom: "1em", width: "auto" }}>
        <tbody>
          <tr>
            <td style={{ width: "120px" }}>
              <strong>ID</strong>
            </td>
            <td className="use-mono-font">{auditlog.id}</td>
          </tr>
          <tr>
            <td>
              <strong>Event Type</strong>
            </td>
            <td>{auditlog.eventType}</td>
          </tr>
          <tr>
            <td>
              <strong>Created</strong>
            </td>
            <td className="use-mono-font">
              {UtilService.isoDateToReadable(auditlog.created)}
            </td>
          </tr>
          <tr>
            <td>
              <strong>User ID</strong>
            </td>
            <td>{auditlog.userId}</td>
          </tr>
        </tbody>
      </table>

      {/* Description - separate section with its own space */}
      {auditlog.description && (
        <>
          <h4>Description</h4>
          <pre className="auditlog-metadata-display">
            {auditlog.description}
          </pre>
        </>
      )}
    </div>
  );
};

export default AuditlogExpandedRow;
